import { NgModule } from '@angular/core';
import { MainPanelComponent } from './panel/main.panel.component';
import { SideComponent } from './containers/side/side.component';
import { MainComponent } from './containers/main/main.component';
import { ApiHttpService } from '../shared/services/api_http.service';
import { AccountService } from '../shared/services/account.service';
import { FeatureService } from './shared/services/feature.service';
import { LogService } from '../shared/services/log.service';
import { ToastService } from '../shared/services/toastr.service';
import { StorageService } from './shared/services/storage.service';
import { UserService } from '../shared/services/user.service';
import { MapModule } from './map/map.module';
import { WidgetModule } from './widget/widget.module';
import { InstallSharedModule } from './shared/install_shared.module';
import { ShopifyService } from './shared/services/shopify.service';
import { ReminderService } from './shared/services/reminder.service';
import { MapStateCreator } from './map/state/map-state-creator';
import { InstallResolve } from './install.resolve';
import { AccountResolver } from './shared/resolvers/account_resolver';
import { WidgetResolver } from './shared/resolvers/widget_resolver';
import { ReminderResolver } from './shared/resolvers/reminder_resolver';
import { MainSideComponent } from './containers/main-side/main-side.component';
import { LayoutComponent } from './layout/layout.component';
import { InstallRoutingModule } from './install.routing';
import { InstallComponent } from './install.component';
import { FeatureResolver } from './shared/resolvers/feature_resolver';
import { WidgetStateCreator } from './widget/state/widget_state_creator';
import { NavigationStateCreator } from './shared/navigation/state/navigation_state_creator';
import { IntegrateModule } from './integrate/integrate.module';
import { IntegrateStateCreator } from './integrate/state/integrate_state_creator';
import { NavigationEffectsService } from './shared/navigation/state/navigation_effects.service';
import { HasFeatureResolver } from './shared/resolvers/has_feature_resolver';
import { RedirectService } from '../shared/services/redirect.service';
import { ManualSetupModule } from './integrate/main/manual_setup/manual_setup.module';
import { ManualSetupStateCreator } from './integrate/main/manual_setup/store/manual_setup_state_creator';
import { SingleComponent } from './containers/single/single.component';
import { MobileMessageComponent } from './mobile/message/mobile_message.component';
import { MobileStateCreator } from './mobile/state/mobile-state-creator';
import { CookieService } from 'ngx-cookie-service';
import { ShopifyResolver } from './shared/resolvers/shopify_resolver';
import { RedCrossAnalyticsTrackingService } from '@yotpo-ui/common-browser';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';
import { PostmanEditorService } from './shared/services/postman-editor.service';
import { LaunchDarklyResolver } from './shared/resolvers/launch_darkly_resolver';
import { LoyaltyHttpService } from '../shared/services/loyalty_http.service';

@NgModule({
  imports: [
    InstallRoutingModule,
    InstallSharedModule,
    MapModule,
    WidgetModule,
    IntegrateModule,
    ManualSetupModule,
  ],
  declarations: [
    InstallComponent,
    LayoutComponent,
    MainPanelComponent,
    SideComponent,
    MainComponent,
    MainSideComponent,
    SingleComponent,
    MobileMessageComponent
  ],
  providers: [
    ApiHttpService,
    LoyaltyHttpService,
    LogService,
    AuthService,
    StorageService,
    AccountService,
    ToastService,
    FeatureService,
    UserService,
    ShopifyService,
    ReminderService,
    PostmanEditorService,
    ReminderResolver,
    AccountResolver,
    WidgetResolver,
    FeatureResolver,
    HasFeatureResolver,
    InstallResolve,
    MapStateCreator,
    WidgetStateCreator,
    NavigationStateCreator,
    IntegrateStateCreator,
    MobileStateCreator,
    NavigationEffectsService,
    RedirectService,
    ManualSetupStateCreator,
    CookieService,
    ShopifyResolver,
    LaunchDarklyResolver,
    {
      provide: AnalyticsTrackingProvider,
      useClass: RedCrossAnalyticsTrackingService
    }
  ],
  bootstrap: [InstallComponent]
})
export class InstallModule {}
